import { render } from "./PartModifier.vue?vue&type=template&id=c8af0afe&scoped=true"
import script from "./PartModifier.vue?vue&type=script&lang=js"
export * from "./PartModifier.vue?vue&type=script&lang=js"

import "./PartModifier.vue?vue&type=style&index=0&id=c8af0afe&scoped=true&lang=css"

import exportComponent from "/container/application/releases/20260729235012/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8af0afe"]])

export default __exports__